import React, {memo} from 'react';

import {SearchDestinationDetailsInputField} from '../SearchDestinationDetailsInputField/SearchDestinationDetailsInputField';
import {SearchDatesDetailsInputField} from '../SearchDatesDetailsInputField/SearchDatesDetailsInputField';
import {SearchGuestsDetailsInputField} from '../SearchGuestsDetailsInputField/SearchGuestsDetailsInputField';
import {SearchSubmitDetailsButtonField} from '../SearchSubmitDetailsButtonField/SearchSubmitDetailsButtonField';

import {useComponent} from './hooks/useComponent';

import './SearchDetailsFields.less';

import '../SearchDetailsField/SearchDetailsField.less';
import '../SearchDetailsInputField/SearchDetailsInputField.less';
import '../SearchDetailsButtonField/SearchDetailsButtonField.less';

const SearchDetailsFields = memo(function SearchDetailsFields() {
    const {
        className,
        showGuestsDetailsInputField,
        showSubmitDetailsButtonField
    } = useComponent();

    return (
        <div className={className}>
            <SearchDestinationDetailsInputField/>
            <SearchDatesDetailsInputField/>
            {showGuestsDetailsInputField && (
                <SearchGuestsDetailsInputField/>
            )}
            {showSubmitDetailsButtonField && (
                <SearchSubmitDetailsButtonField/>
            )}
        </div>
    );
});

SearchDetailsFields.whyDidYouRender = true;

export {SearchDetailsFields};
